@if (!scanCards()) {
  <form [formGroup]="prospectForm" (ngSubmit)="submitProspectsForm()" autocomplete="off">
    @if (enableCardScan()) {
      <div class="bg-info-subtle rounded-3">
        <!-- <button
          type="button"
          class="btn btn-h42 btn-primary justify-content-center text-center px-5"
          (click)="prospectForm.reset(); scanCards.set(true)"
        >
          <i class="bi bi-upc-scan"></i> Scan Card
        </button>
        <span class="fs-16 text-center"
          >Quickly capture contact details from a Passport, Driving License, Business Card or Other ID</span
        > -->
        <form (submit)="submitImages($event)" autocomplete="off">
          <div class="row">
            <div class="col-md-12">
              <!-- <div class="bg-gray-200 p-2 mb-3">
                <h3 class="text-center mb-0">Front Side</h3>
              </div> -->
              <file-drop
                [fileAcceptedFormat]="'.png,.jpg,.jpeg'"
                [titleMsg]="'Upload card to scan'"
                [buttonText]="'Drag and Drop or'"
                (onFileDrop)="onFileDrop($event, 'front')"
              ></file-drop>
              @if (frontImage()) {
                <div class="d-flex align-items-center gap-2 my-2">
                  <i class="bi bi-file-earmark-image fs-18 text-primary"></i>
                  <span class="fw-500">
                    {{ frontImage()?.file?.name || 'File selected' }}
                  </span>
                </div>
                <!-- <div class="d-flex flex-column flex-md-row bg-gray-200 cardview gallery-box gap-4 my-3 p-3 rounded-2">
                  <img [src]="frontImage()?.fileSrcUrl" class="img-fluid" />

                  @if (frontImage()?.progress) {
                    <p-progressbar [value]="frontImage()?.progress" />
                  }
                  <div class="d-flex justify-content-center gap-2 d-md-none">
                    <button type="button" (click)="captureFront.click()" class="btn btn-dark btn-h42">
                      <i class="bi bi-camera fs-16"></i> Take Picture
                    </button>
                  </div>
                </div> -->
              } @else {
                <div class="d-flex flex-column d-md-none">
                  <h4 class="text-center text-gray-400">or</h4>
                  <div class="d-flex justify-content-center mb-3">
                    <button type="button" (click)="captureFront.click()" class="btn btn-dark btn-h42">
                      <i class="bi bi-camera fs-16"></i> Take Picture
                    </button>
                  </div>
                </div>
              }
            </div>
            <!-- <div class="col-md-6">
              <div class="bg-gray-200 p-2 mb-3">
                <h3 class="text-center mb-0">Back Side</h3>
              </div>
              <file-drop
                [fileAcceptedFormat]="'.png,.jpg,.jpeg'"
                [titleMsg]="'Click to upload'"
                (onFileDrop)="onFileDrop($event, 'back')"
              ></file-drop>
              @if (backImage()) {
                <div class="d-flex flex-column flex-md-row bg-gray-200 cardview gallery-box gap-4 my-3 p-3 rounded-2">
                  <img [src]="backImage()?.fileSrcUrl" class="img-fluid" />
                  @if (backImage()?.progress) {
                    <p-progressbar [value]="backImage()?.progress" />
                  }
                  <div class="d-flex justify-content-center gap-2 d-md-none">
                    <button type="button" (click)="captureBack.click()" class="btn btn-dark btn-h42">
                      <i class="bi bi-camera fs-16"></i> Take Picture
                    </button>
                  </div>
                </div>
              } @else {
                <div class="d-flex flex-column d-md-none">
                  <h4 class="text-center text-gray-400">or</h4>
                  <div class="d-flex justify-content-center mb-3">
                    <button type="button" (click)="captureBack.click()" class="btn btn-dark btn-h42">
                      <i class="bi bi-camera fs-16"></i> Take Picture
                    </button>
                  </div>
                </div>
              }
            </div> -->
          </div>
        </form>
      </div>

      <div class="divider d-flex align-items-center fs-14">
        <span class="px-3">or enter manually</span>
      </div>

      <h4 class="mb-2">
        <i class="bi bi-person text-primary me-2"></i>
        Basic Information
      </h4>

      <hr class="mt-0 border-dark-subtle" />
    }
    <div class="row gy-3">
      <div class="col-xl-3 col-sm-6">
        <generic-dropdown
          [items]="titlesList()"
          [label]="'Title'"
          [placeholder]="'Select Title'"
          formControlName="title"
        ></generic-dropdown>
      </div>
      <div class="col-xl-3 col-sm-6">
        <input-field
          [label]="'First Name'"
          [type]="'text'"
          [placeholder]="'ex: John'"
          formControlName="firstName"
          [requiredLabel]="true"
          [required]="true"
          [errormessage]="'First name is required'"
        ></input-field>
        <!-- @if (
          prospectForm.get('firstName')?.hasError('required') &&
          (prospectForm.get('firstName')?.touched || prospectForm.get('firstName')?.dirty)
        ) {
          <div class="text-danger">First Name is required</div>
        } -->
      </div>

      <div class="col-xl-3 col-sm-6">
        <input-field
          [label]="'Middle Name'"
          [type]="'text'"
          [placeholder]="'ex: Michael'"
          formControlName="middleName"
        ></input-field>
      </div>

      <div class="col-xl-3 col-sm-6">
        <input-field
          [label]="'Last Name'"
          [type]="'text'"
          [placeholder]="'ex: Doe'"
          formControlName="lastName"
          [requiredLabel]="true"
          [errormessage]="'Last name is required'"
        ></input-field>
      </div>
      <div class="col-xl-3 col-sm-6">
        <input-field
          [label]="'SIN/SSN'"
          [type]="'text'"
          [placeholder]="'ex: 1234567890'"
          formControlName="ssn"
        ></input-field>
      </div>
      <div class="col-xl-3 col-sm-6">
        <label class="form-label d-block">Date of Birth</label>
        <p-datepicker
          placeholder="ex: 1990-01-01"
          [showClear]="true"
          [showIcon]="true"
          [iconDisplay]="'input'"
          [dateFormat]="'yy-mm-dd'"
          [maxDate]="maxDate"
          formControlName="dob"
          styleClass="w-100"
        ></p-datepicker>
      </div>
      <div class="col-xl-3 col-sm-6">
        <generic-dropdown
          [items]="salesOfficesFiltered()"
          [label]="'Sales Office'"
          [allowSearch]="true"
          [clearable]="true"
          [placeholder]="'Select'"
          formControlName="salesOfficeId"
          [required]="true"
          [errormessage]="'Sales Office is required'"
        >
        </generic-dropdown>
      </div>

      <div class="col-12">
        <h4 class="mb-2">
          <i class="bi bi-geo-alt text-primary me-2"></i>
          Address
        </h4>

        <hr class="mt-0 border-dark-subtle" />
      </div>
    </div>
    <ng-container formGroupName="address">
      <div class="row gy-3">
        <div class="col-xl-12 col-sm-6">
          <input-field
            [label]="'Address Line 1'"
            [type]="'text'"
            [placeholder]="'ex: 123 Main St'"
            formControlName="addressLine1"
            [requiredLabel]="true"
            [errormessage]="'Address line 1 is required'"
          ></input-field>
        </div>
        <div class="col-xl-8 col-sm-6">
          <input-field
            [label]="'Address Line 2'"
            [type]="'text'"
            [placeholder]="'ex: Apt 1'"
            formControlName="addressLine2"
          ></input-field>
        </div>
        <!-- <div class="col-xl-3 col-sm-6">
          <input-field
            [label]="'Suite'"
            [type]="'text'"
            [placeholder]="'Enter Suite'"
            formControlName="suite"
          ></input-field>
        </div> -->
        <div class="col-xl-3 col-sm-6">
          <input-field
            [label]="'Post Code/ZIP Code'"
            [type]="'text'"
            [placeholder]="'ex: A1B 2C3'"
            formControlName="postalCode"
            [requiredLabel]="true"
            [errormessage]="'Post code/ZIP code is required'"
          ></input-field>
        </div>
        <div class="col-xl-3 col-sm-6">
          <generic-dropdown
            [items]="countries$()"
            [label]="'Country'"
            [allowSearch]="true"
            [clearable]="true"
            [placeholder]="'Select'"
            formControlName="countryId"
          ></generic-dropdown>
        </div>
        <div class="col-xl-3 col-sm-6">
          <generic-dropdown
            [items]="provincesByCountryIdDisplayList()"
            [label]="'Province/State'"
            [allowSearch]="true"
            [clearable]="true"
            [placeholder]="'Select'"
            formControlName="provinceId"
          ></generic-dropdown>
        </div>

        <div class="col-xl-3 col-sm-6">
          <generic-dropdown
            [items]="citiesByProvinceIdDisplayList()"
            [label]="'City'"
            [allowSearch]="true"
            [clearable]="true"
            [placeholder]="'Select'"
            formControlName="cityId"
            [required]="true"
            [errormessage]="'City is required'"
            [virtualScroll]="true"
            [virtualScrollItemSize]="48"
          ></generic-dropdown>
        </div>
      </div>
    </ng-container>

    <div class="row gy-3 mt-3">
      <div class="col-12">
        <h4 class="mb-2">
          <i class="bi bi-phone text-primary me-2"></i>
          Contact Details
        </h4>

        <hr class="mt-0 border-dark-subtle" />
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <phone-number-field [required]="false" formControlName="phones"></phone-number-field>
          </div>
          <div class="col-md-3 col-sm-6 mt-1">
            <input-field
              [label]="'Email'"
              [type]="'email'"
              [placeholder]="'ex: john.doe@example.com'"
              formControlName="email"
              [requiredLabel]="true"
              [errormessage]="'Valid email is required'"
            ></input-field>
          </div>
        </div>
      </div>
    </div>
    @if (!isPublic()) {
      <div class="row mt-3">
        <div class="col-12">
          <h4 class="mb-2">
            <i class="bi bi-people text-primary me-2"></i>
            Primary Agents
          </h4>

          <hr class="mt-0 border-dark-subtle" />

          <div class="row gy-3">
            <div class="col-xl-3 col-sm-6">
              <generic-dropdown
                [items]="salesAgentsDisplayList()"
                [label]="'Sales Agent'"
                [allowSearch]="true"
                [clearable]="true"
                [placeholder]="'Select'"
                formControlName="salesAgentId"
              ></generic-dropdown>
            </div>
            <div class="col-xl-3 col-sm-6">
              <generic-dropdown
                [items]="agencyRealtorsDisplayList()"
                [label]="'R/E Agent'"
                [allowSearch]="true"
                [clearable]="true"
                [placeholder]="'Select'"
                formControlName="realtorId"
              ></generic-dropdown>
            </div>
            <div class="col-xl-3 col-sm-6">
              <input-field
                [label]="'Brokerage'"
                [type]="'text'"
                [placeholder]="'Agency Name'"
                formControlName="agencyName"
                [disabled]="true"
              ></input-field>
            </div>
            <div class="col-xl-3 col-sm-6">
              <input-field
                [label]="'Address'"
                [type]="'text'"
                [placeholder]="'Agency Address'"
                formControlName="agencyAddress"
                [disabled]="true"
              ></input-field>
            </div>
          </div>
        </div>
      </div>
    }
    <!-- reCAPTCHA widget - only show when enabled -->
    @if (enableRecaptcha()) {
      <div class="row mt-3">
        <div class="col-xl-3 col-sm-6">
          <h4 class="mb-2">
            <i class="bi bi-shield-check text-primary me-2"></i>
            Verification
          </h4>
          <hr class="mt-0 border-dark-subtle" />
          <div id="recaptcha-container" class=""></div>
        </div>
      </div>
    }
  </form>
} @else {}

<input
  #captureFront
  type="file"
  capture="environment"
  accept="image/*"
  (change)="onFileChange($event, 'front')"
  class="d-none"
/>
<input
  #captureBack
  type="file"
  capture="environment"
  accept="image/*"
  (change)="onFileChange($event, 'back')"
  class="d-none"
/>
